<template>
    <DsAvatarBase
        :config="{
            type: 'icon',
            size,
            icon,
        }"
    />
</template>

<script setup lang="ts">
import type { IconAvatarProps } from './DsAvatarBase.vue';
import DsAvatarBase from './DsAvatarBase.vue';

defineProps<Omit<IconAvatarProps, 'type'>>();
</script>
